const OptionButton = ({ label, selected, onClick, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className={`group w-full flex items-center gap-4 text-left px-5 py-4 border transition-colors duration-200 ${
      selected
        ? "border-[#FFD166] bg-[#FFD166]/[0.08]"
        : "border-white/10 hover:border-[#9D4EDD]/60 hover:bg-white/[0.03]"
    }`}
  >
    <span
      className={`shrink-0 w-4 h-4 rounded-full border flex items-center justify-center transition-colors duration-200 ${
        selected ? "border-[#FFD166]" : "border-white/25 group-hover:border-[#9D4EDD]/70"
      }`}
    >
      <span
        className={`w-2 h-2 rounded-full bg-[#FFD166] transition-transform duration-200 ${
          selected ? "scale-100" : "scale-0"
        }`}
      />
    </span>
    <span className={`font-light ${selected ? "text-white" : "text-white/80"}`}>{label}</span>
  </button>
);

export default OptionButton;
